<template>  
 <v-list expand>    
      <v-list-tile :value="true" :to="{name:'NewMapLayer'}"   >           
          <v-list-tile-action><v-icon>mdi-map</v-icon></v-list-tile-action>
          <v-list-tile-content>                
            <v-list-tile-title >{{$t('Configuration.MapLayers')}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>   
     <!-- <v-list-group prepend-icon="mdi-database" no-action>          
        <template v-slot:activator>
           <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>{{$t('Configuration.WmsLayer')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>          
        </template>
        <v-list-tile :value="true" :to="{name:'Home'}"   >           
          <v-list-tile-action><v-icon class="ml-2">mdi-sitemap</v-icon></v-list-tile-action>
          <v-list-tile-content>                
            <v-list-tile-title >Titre 2</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>   
        <v-list-tile :value="true" :to="{name:'Home'}"   >           
          <v-list-tile-action><v-icon class="ml-2">mdi-sitemap</v-icon></v-list-tile-action>
          <v-list-tile-content>                
            <v-list-tile-title >Titre 2</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>         
      </v-list-group>  
      <v-divider class="my-0"></v-divider>      
      <v-list-group prepend-icon="mdi-database" no-action>          
        <template v-slot:activator>
           <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>{{$t('Configuration.WmsLayers')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>          
        </template>
        <v-list-tile :value="true" :to="{name:'Home'}"   >           
          <v-list-tile-action><v-icon class="ml-2">mdi-sitemap</v-icon></v-list-tile-action>
          <v-list-tile-content>                
            <v-list-tile-title >Titre 2</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>   
        <v-list-tile :value="true" :to="{name:'Home'}"   >           
          <v-list-tile-action><v-icon class="ml-2">mdi-sitemap</v-icon></v-list-tile-action>
          <v-list-tile-content>                
            <v-list-tile-title >Titre 2</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>         
      </v-list-group>  -->    
  </v-list>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'ConfigurationMenu', 
})
export default class ConfigurationMenu extends Vue {  

  

}
</script>
<style>
.v-list__group__items--no-action .v-list__tile {
    padding-left: 32px;
}
</style>